module.exports = __webpack_public_path__ + "static/img/Best-in-class.d81a065a.svg";